import { AxiosRequestConfig } from 'axios';

export const authorizationHeaderInterceptor = (config: AxiosRequestConfig) => {
    const token = localStorage.getItem('accessToken');
    config.headers = {
        ...config.headers,
        ...(token && { Authorization: `Bearer ${token}` })
    };

    return config;
};
